import { RouterModule } from '@angular/router';
import { PublicComponent } from './public.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';

import { LoginComponent } from './login/login.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {MatFormFieldModule} from '@angular/material/form-field';

import { MatIcon } from '@angular/material/icon';
/* import {NgTiltModule} from '@geometricpanda/angular-tilt'; */

@NgModule({
    declarations: [
      PublicComponent,
      LoginComponent,
    ],
    imports: [
      CommonModule,
      RouterModule,
      ReactiveFormsModule,
      HttpClientModule,
      FontAwesomeModule,
      MatIconModule,
      MatFormFieldModule
    ]
  })
  export class PublicModule { }
